// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader_loaderBackdrop__pYcA8 {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.507); /* Полупрозрачный фон */
    z-index: 9999; /* Поверх всего */
}

.loader_loaderCircle__326Nc {
    border: 9px solid rgba(43, 134, 104, 0.3);
    border-radius: 50%;
    border-top: 9px solid darkgreen; /* Темно-зеленый цвет */
    width: 55px;
    height: 55px;
    animation: loader_spin__XkrLf 2s linear infinite;
}

@keyframes loader_spin__XkrLf {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/shared/Ui/Loader/loader.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,4CAA4C,EAAE,uBAAuB;IACrE,aAAa,EAAE,iBAAiB;AACpC;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;IAClB,+BAA+B,EAAE,uBAAuB;IACxD,WAAW;IACX,YAAY;IACZ,gDAAkC;AACtC;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC","sourcesContent":[".loaderBackdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: rgba(255, 255, 255, 0.507); /* Полупрозрачный фон */\n    z-index: 9999; /* Поверх всего */\n}\n\n.loaderCircle {\n    border: 9px solid rgba(43, 134, 104, 0.3);\n    border-radius: 50%;\n    border-top: 9px solid darkgreen; /* Темно-зеленый цвет */\n    width: 55px;\n    height: 55px;\n    animation: spin 2s linear infinite;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loaderBackdrop": `loader_loaderBackdrop__pYcA8`,
	"loaderCircle": `loader_loaderCircle__326Nc`,
	"spin": `loader_spin__XkrLf`
};
export default ___CSS_LOADER_EXPORT___;
